// Merkan · Branche des Mandanten (Admin Center › Mandanten › Branche).
// Sie steuert branchenspezifische Bereiche und Beispieltexte. Die Schiffsakte (Schiffe, IMO, Seeschifffahrt)
// gibt es nur in der Branche maritim; alle übrigen Mandanten sehen eine branchenneutrale Oberfläche.
import { useSession } from './session';

export type Branche = 'neutral' | 'maritim' | 'grosshandel' | 'handwerk';

export interface BrancheProfil {
  branche: Branche;
  /** Schiffsakte, Schiffsbezug in Vorgängen, IMO-Suche, Steuerart Seeschifffahrt, Hafen und Handelsrechnung für Schiffe */
  schiffe: boolean;
}

const BEKANNT: Branche[] = ['neutral', 'maritim', 'grosshandel', 'handwerk'];

export function brancheProfil(roh: string | null | undefined): BrancheProfil {
  const branche = (BEKANNT as string[]).includes(roh ?? '') ? (roh as Branche) : 'neutral';
  return { branche, schiffe: branche === 'maritim' };
}

// Für Hilfsfunktionen außerhalb von React (Variablen, Begriffe); die Sitzung setzt den Wert beim Mandantenwechsel
let aktuell: BrancheProfil = brancheProfil('neutral');
export function brancheSetzen(roh: string | null | undefined): void { aktuell = brancheProfil(roh); }
export function aktuelleBranche(): BrancheProfil { return aktuell; }

/** Branche des gewählten Mandanten */
export function useBranche(): BrancheProfil {
  const { mandant } = useSession();
  return brancheProfil(mandant?.branche);
}
